<div class="position-relative h-100">
  <div
    class="text-start c-pointer h-100"
    [ngClass]="{
      'opacity-50': isOutOfStock(product),
      'product-layout-right': isRightLayout(),
      'product-layout-left': isLeftLayout(),
      'product-layout-top': isTopLayout(),
      'product-layout-bottom': isBottomLayout()
    }"
    [ngStyle]="
      categoryGroup
        ? getLayoutStyle(categoryGroup.gridChildViewConfig, isInsideLayout())
        : customConfig && customConfig.isSetCustomDesign
        ? getLayoutStyle(customConfig.gridChildViewConfig, isInsideLayout())
        : null
    "
  >
    <div
      class="product-card"
      [ngStyle]="
        categoryGroup
          ? getProductCardStyle(categoryGroup.gridChildViewConfig, isInsideLayout())
          : customConfig && customConfig.isSetCustomDesign
          ? getProductCardStyle(customConfig.gridChildViewConfig, isInsideLayout())
          : null
      "
    >
      <div
        [ngStyle]="
          categoryGroup
            ? getGridItemStyle(categoryGroup.gridChildViewConfig)
            : customConfig && customConfig.isSetCustomDesign
            ? getGridItemStyle(customConfig.gridChildViewConfig)
            : null
        "
        class="position-relative"
        [ngClass]="!categoryGroup ? 'd-flex flex-column justify-content-center align-items-center text-center p-1' : ''"
      >
        <div class="aspect-ratio-box d-flex justify-content-center" (click)="onProductClick($event)" [ngStyle]="{ width: isRightLayout() || isLeftLayout() ? '9.5rem' : '' }">
          <img
            [src]="getProductImage()"
            [ngStyle]="
              categoryGroup
                ? getGridItemImageStyle(categoryGroup.gridChildViewConfig.image)
                : customConfig && customConfig.isSetCustomDesign
                ? getGridItemImageStyle(customConfig.gridChildViewConfig.image)
                : null
            "
            alt="Product Image"
            class="h-100 w-100 object-fit-cover img"
          />
          @if(product.highlightedTags && product.highlightedTags[0] && product.variants && product.variants.length === 1 && product.variants[0] && product.variants[0].status !==
          'OUT_OF_STOCK'){
          <div [ngStyle]="{ 'background-color': product.highlightedTags[0].bgColor }" class="tag-container d-flex align-items-center gap-1 position-absolute top-0 px-1">
            @if(product.highlightedTags[0].imageUrl){
            <img [src]="helper.imageUrl + product.highlightedTags[0].imageUrl" alt="Tag Image" width="10" height="10" />
            }
            <span [ngStyle]="{ color: product.highlightedTags[0].textColor }" class="tag-text">{{ product.highlightedTags[0].name | translate }}</span>
          </div>
          }
        </div>
        @if((isDelivery || isServices) && ((product.modifiers && product.modifiers.length > 0) || (product.variants && product.variants.length > 1))) {
        @if(totalQuantity(product.variants) === 0) {
        <button
          class="add-button"
          [ngStyle]="
            categoryGroup && categoryGroup.gridChildViewConfig.button
              ? getButtonStyle(categoryGroup.gridChildViewConfig.button)
              : customConfig && customConfig.isSetCustomDesign && customConfig.gridChildViewConfig.button
              ? getButtonStyle(customConfig.gridChildViewConfig.button)
              : null
          "
          (click)="openProductCustomizationModal(product)"
          @buttonTransition
        >
          <span class="white">{{ "button-title.customize" | translate }}</span>
        </button>
        } @else {
        <div
          class="add-button gap-2"
          [ngStyle]="
            categoryGroup && categoryGroup.gridChildViewConfig.button
              ? getButtonStyle(categoryGroup.gridChildViewConfig.button)
              : customConfig && customConfig.isSetCustomDesign && customConfig.gridChildViewConfig.button
              ? getButtonStyle(customConfig.gridChildViewConfig.button)
              : null
          "
          @buttonTransition
        >
          <button
            class="button"
            (click)="openRepeatLastCustomizationModal(product)"
            [ngStyle]="{
              color:
                categoryGroup && categoryGroup.gridChildViewConfig.button
                  ? categoryGroup.gridChildViewConfig.button.color
                  : customConfig && customConfig.isSetCustomDesign && customConfig.gridChildViewConfig.button
                  ? customConfig.gridChildViewConfig.button.color
                  : ''
            }"
          >
            <i class="ri-subtract-line"></i>
          </button>
          <span class="white" [@quantityChangeAnimation]="totalQuantity(product.variants)">{{ totalCustomizedProductQuantity(product.variants) }}</span>
          <button
            class="button"
            (click)="openRepeatLastCustomizationModal(product)"
            [ngStyle]="{
              color:
                categoryGroup && categoryGroup.gridChildViewConfig.button
                  ? categoryGroup.gridChildViewConfig.button.color
                  : customConfig && customConfig.isSetCustomDesign && customConfig.gridChildViewConfig.button
                  ? customConfig.gridChildViewConfig.button.color
                  : ''
            }"
          >
            <i class="ri-add-line"></i>
          </button>
        </div>
        } } @else if(product.variants && product.variants.length > 1) { @if(totalQuantity(product.variants) === 0) {
        <button
          class="add-button"
          [ngStyle]="
            categoryGroup && categoryGroup.gridChildViewConfig.button
              ? getButtonStyle(categoryGroup.gridChildViewConfig.button)
              : customConfig && customConfig.isSetCustomDesign && customConfig.gridChildViewConfig.button
              ? getButtonStyle(customConfig.gridChildViewConfig.button)
              : null
          "
          (click)="openProductVariantsModal(product)"
          @buttonTransition
        >
          <span class="white">{{ "button-title.variant-options-qd" | translate : { _VALUE: product.variants.length } }}</span>
        </button>
        } @else {
        <div
          class="add-button gap-2"
          [ngStyle]="
            categoryGroup && categoryGroup.gridChildViewConfig.button
              ? getButtonStyle(categoryGroup.gridChildViewConfig.button)
              : customConfig && customConfig.isSetCustomDesign && customConfig.gridChildViewConfig.button
              ? getButtonStyle(customConfig.gridChildViewConfig.button)
              : null
          "
          @buttonTransition
        >
          <button
            class="button"
            (click)="openProductVariantsModal(product)"
            [ngStyle]="{
              color:
                categoryGroup && categoryGroup.gridChildViewConfig.button
                  ? categoryGroup.gridChildViewConfig.button.color
                  : customConfig && customConfig.isSetCustomDesign && customConfig.gridChildViewConfig.button
                  ? customConfig.gridChildViewConfig.button.color
                  : ''
            }"
          >
            <i class="ri-subtract-line"></i>
          </button>
          <span class="white" [@quantityChangeAnimation]="totalQuantity(product.variants)">{{ totalQuantity(product.variants) }}</span>
          <button
            class="button"
            (click)="openProductVariantsModal(product)"
            [ngStyle]="{
              color:
                categoryGroup && categoryGroup.gridChildViewConfig.button
                  ? categoryGroup.gridChildViewConfig.button.color
                  : customConfig && customConfig.isSetCustomDesign && customConfig.gridChildViewConfig.button
                  ? customConfig.gridChildViewConfig.button.color
                  : ''
            }"
          >
            <i class="ri-add-line"></i>
          </button>
        </div>
        } } @else { @if (product.variants && product.variants[0] && !getVariantQuantity(product.variants[0]._id)) {
        <button
          class="add-button"
          [ngStyle]="
            categoryGroup && categoryGroup.gridChildViewConfig.button
              ? getButtonStyle(categoryGroup.gridChildViewConfig.button)
              : customConfig && customConfig.isSetCustomDesign && customConfig.gridChildViewConfig.button
              ? getButtonStyle(customConfig.gridChildViewConfig.button)
              : null
          "
          (click)="addProductToCart(product.variants[0])"
          @buttonTransition
        >
          <span
            class="icon"
            [ngStyle]="
              categoryGroup && categoryGroup.gridChildViewConfig.button
                ? { color: categoryGroup.gridChildViewConfig.button.bgColor, backgroundColor: categoryGroup.gridChildViewConfig.button.color }
                : customConfig && customConfig.isSetCustomDesign && customConfig.gridChildViewConfig.button
                ? { color: customConfig.gridChildViewConfig.button.bgColor, backgroundColor: customConfig.gridChildViewConfig.button.color }
                : null
            "
            ><i class="ri-add-line"></i
          ></span>
          {{ "button-title.add" | translate }}
        </button>
        } @else if(helper.route.url.includes('/users/create-booking/services') && product.variants && product.variants[0] && product.variants[0].maxQtyAddInCart === 1) {
        <button
          class="add-button"
          [ngStyle]="
            categoryGroup && categoryGroup.gridChildViewConfig.button
              ? getButtonStyle(categoryGroup.gridChildViewConfig.button)
              : customConfig && customConfig.isSetCustomDesign && customConfig.gridChildViewConfig.button
              ? getButtonStyle(customConfig.gridChildViewConfig.button)
              : null
          "
          (click)="decrementProductQuantity(product.variants[0])"
          @buttonTransition
        >
          {{ "button-title.remove-product" | translate }}
        </button>
        } @else if(product.variants && product.variants[0] && getVariantQuantity(product.variants[0]._id)) {
        <div
          class="add-button gap-2"
          [ngStyle]="
            categoryGroup && categoryGroup.gridChildViewConfig.button
              ? getButtonStyle(categoryGroup.gridChildViewConfig.button)
              : customConfig && customConfig.isSetCustomDesign && customConfig.gridChildViewConfig.button
              ? getButtonStyle(customConfig.gridChildViewConfig.button)
              : null
          "
          @buttonTransition
        >
          <button
            class="button"
            (click)="decrementProductQuantity(product.variants[0])"
            [ngStyle]="{
              color:
                categoryGroup && categoryGroup.gridChildViewConfig.button
                  ? categoryGroup.gridChildViewConfig.button.color
                  : customConfig && customConfig.isSetCustomDesign && customConfig.gridChildViewConfig.button
                  ? customConfig.gridChildViewConfig.button.color
                  : ''
            }"
          >
            <i class="ri-subtract-line"></i>
          </button>
          <span class="white" [@quantityChangeAnimation]="getVariantQuantity(product.variants[0]._id)">{{ getVariantQuantity(product.variants[0]._id) }}</span>
          <button
            class="button"
            (click)="incrementProductQuantity(product.variants[0])"
            [ngStyle]="{
              color:
                categoryGroup && categoryGroup.gridChildViewConfig.button
                  ? categoryGroup.gridChildViewConfig.button.color
                  : customConfig && customConfig.isSetCustomDesign && customConfig.gridChildViewConfig.button
                  ? customConfig.gridChildViewConfig.button.color
                  : ''
            }"
            [disabled]="getVariantQuantity(product.variants[0]._id) === product.variants[0].maxQtyAddInCart"
          >
            <i class="ri-add-line"></i>
          </button>
        </div>
        } } @if(product.variants && product.variants.length === 1 && product.variants[0] && product.variants[0].status === 'OUT_OF_STOCK'){
        <div class="d-flex justify-content-center w-100 position-absolute top-0">
          <span class="px-2 bg-danger text-white tag-text tag-container">{{ "label-title.out-of-stock" | translate }}</span>
        </div>
        }
      </div>
    </div>
    <div
      class="mt-2"
      [ngStyle]="
        categoryGroup
          ? getProductInfoStyle(categoryGroup.gridChildViewConfig, isInsideLayout())
          : customConfig && customConfig.isSetCustomDesign
          ? getProductInfoStyle(customConfig.gridChildViewConfig, isInsideLayout())
          : null
      "
    >
      <div class="d-flex flex-wrap gap-1">
        @if(product.variantType === helper.VariantType.UNIT && product.variants && product.variants[0]){
        <div class="product-tags overflow-hidden">
          <span class="text-ellipsis product-tag"> {{ product.variants[0].unit.unitValue }} {{ helper.UnitTypeString[product.variants[0].unit.unitType] | translate }} </span>
        </div>
        } @else if (product.variantType === helper.VariantType.SIZE && product.variants && product.variants[0].unit.unitDescription){
        <div class="product-tags overflow-hidden">
          <span class="text-ellipsis product-tag">{{
            product.variants && product.variants[0] && product.variants[0].unit.unitQty === 1
              ? product.variants[0].unit.unitDescription
              : product.variants[0].unit.unitQty + " x " + product.variants[0].unit.unitDescription
          }}</span>
        </div>
        } @if(product.attributeCollection && product.attributeCollection.length > 0) { @for(attributeGroup of product.attributeCollection; track $index) {
        @if(attributeGroup.attributes.length > 0) { @for(attribute of attributeGroup.attributes; track $index) { @if(attribute.isHighlighted) {
        <div class="product-tags">
          <span class="product-tag">{{ attribute.value }}</span>
        </div>
        } } } } }
      </div>
      <span
        [ngStyle]="
          categoryGroup
            ? getTitleStyle(categoryGroup.gridChildViewConfig.title)
            : customConfig && customConfig.isSetCustomDesign
            ? getTitleStyle(customConfig.gridChildViewConfig.title)
            : null
        "
        class="ellipsis-text product-title"
      >
        {{ product.name }}
      </span>
      @if (product.variants && product.variants[0] && calculateDiscountPercentage(product.variants[0].discountedPrice, product.variants[0].price)) {
      <div class="product-offer">
        <span class="offer-badge">
          {{ "label-title.off-qd" | translate : { _VALUE: calculateDiscountPercentage(product.variants[0].discountedPrice, product.variants[0].price) } }}
        </span>
      </div>
      } @if(!isBrandType) {
      <div class="product-price" [ngClass]="{ 'justify-content-between': !isRightLayout() && !isLeftLayout() }">
        <div
          class="d-flex ms-1 align-items-center current-price"
          [ngStyle]="
            categoryGroup && categoryGroup.gridChildViewConfig.price
              ? getPriceStyle(categoryGroup.gridChildViewConfig.price, false)
              : customConfig && customConfig.isSetCustomDesign && customConfig.gridChildViewConfig.price
              ? getPriceStyle(customConfig.gridChildViewConfig.price, false)
              : null
          "
        >
          <span>
            {{
              product.variants && product.variants[0]
                ? product.variants[0].discountedPrice === 0
                  ? (0).toFixed(helper.adminSettings?.decimalPointValue)
                  : product.variants[0].discountedPrice.toFixed(helper.adminSettings?.decimalPointValue)
                : ""
            }}
          </span>
          <span [ngClass]="{ 'order-first': helper.adminSettings?.setCurrencySign == helper.SetCurrencySignUnit.LEFT }">
            {{ helper.currencySign }}
          </span>
        </div>
        <div
          class="d-flex ms-1 align-items-center original-price"
          [ngStyle]="
            categoryGroup && categoryGroup.gridChildViewConfig.price
              ? getPriceStyle(categoryGroup.gridChildViewConfig.price, true)
              : customConfig && customConfig.isSetCustomDesign && customConfig.gridChildViewConfig.price
              ? getPriceStyle(customConfig.gridChildViewConfig.price, true)
              : null
          "
        >
          <span>
            {{
              product.variants && product.variants[0] && product.variants[0].discountedPrice !== product.variants[0].price
                ? product.variants[0].price.toFixed(helper.adminSettings?.decimalPointValue)
                : ""
            }}
          </span>
          <span [ngClass]="{ 'order-first': helper.adminSettings?.setCurrencySign == helper.SetCurrencySignUnit.LEFT }">
            {{ product.variants && product.variants[0] && product.variants[0].discountedPrice !== product.variants[0].price ? helper.currencySign : "" }}
          </span>
        </div>
      </div>
      }
    </div>
  </div>
</div>
@if(isShowModal){
<app-product-variant-modal
  [merchantId]="merchantId"
  [isDelivery]="isDelivery"
  [product]="selectedProduct"
  [serviceMainCategory]="serviceMainCategory"
  [gridChildViewConfig]="categoryGroup ? categoryGroup.gridChildViewConfig : customConfig && customConfig.isSetCustomDesign ? customConfig.gridChildViewConfig : null"
  (closeModal)="closeProductVariantsModal()"
>
</app-product-variant-modal>
}
<app-clear-cart-modal #clearCartModal (onModalClosed)="onChangeMerchantModalClosed($event)"></app-clear-cart-modal>
<app-change-merchant-modal #changeMerchantModal (onModalClosed)="onChangeMerchantModalClosed($event)" [isDeliveryBusiness]="isDelivery"></app-change-merchant-modal>
<app-change-service-modal #changeServiceModal (onModalClosed)="onChangeMerchantModalClosed($event)"></app-change-service-modal>
<app-product-customization-modal
  #customizationModal
  [serviceMainCategory]="serviceMainCategory"
  [gridChildViewConfig]="categoryGroup ? categoryGroup.gridChildViewConfig : customConfig && customConfig.isSetCustomDesign ? customConfig.gridChildViewConfig : null"
></app-product-customization-modal>
<app-product-repeat-last-customization-modal
  #lastCustomizationModal
  (openProductCustomizationModal)="openProductCustomizationModal($event)"
  [gridChildViewConfig]="categoryGroup ? categoryGroup.gridChildViewConfig : customConfig && customConfig.isSetCustomDesign ? customConfig.gridChildViewConfig : null"
></app-product-repeat-last-customization-modal>
